import { PathRequestPartStatusEnum, PathRequestPartTypeEnum } from '@elearning-platform/api-types/enums';
import { PathPartInfoInterface } from '@elearning-platform/api-types/interfaces';

export const isPartInStatuses: (
  statuses: PathRequestPartStatusEnum[],
  parts: Partial<Record<PathRequestPartTypeEnum, PathPartInfoInterface>>,
  part: PathRequestPartTypeEnum
) => boolean = (
  statuses: PathRequestPartStatusEnum[],
  parts: Partial<Record<PathRequestPartTypeEnum, PathPartInfoInterface>>,
  part: PathRequestPartTypeEnum
): boolean => {
  const partObject: PathPartInfoInterface | undefined = parts[part];

  return !!partObject?.status && statuses.includes(partObject.status);
};
